var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChords = function SvgChords(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.75 1.25A2.75 2.75 0 0 0 3 4v18.75h1.5v-7.5h4v3.645a2 2 0 1 0 1.5 0V15.25h4v7.5h1.5v-7.5h4v7.5H21V4a2.75 2.75 0 0 0-2.75-2.75zm2.75 12.5h-4V4c0-.69.56-1.25 1.25-1.25H8.5zm1.5 0v-11h4v3.645a2 2 0 0 0 0 3.71v3.645zm5.5-3.645v3.645h4V4c0-.69-.56-1.25-1.25-1.25H15.5v3.645a2 2 0 0 1 0 3.71",
    clipRule: "evenodd"
  })));
};
export default SvgChords;